





































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Subscription } from 'vue-rx-decorators';
import TabsComponent from './tabs.vue';
import { Sessions, InmateSource } from '@lantern/lantern-sdk';
import { Session } from '@lantern/models';
import { Cache } from '../../common/cache';

import { alert } from '@/common/modal';

enum SessionRresults {
    empty = '-',
    completed = 'completed',
    resend = 're-send task',
    seeDetails = 'see details',
    sessionFailed = 'failed',
    sessionPartialFailed = 'completed with errors',
    sessionInProgress = 'processing...'
};

interface SessionProgress extends Session.Document {
        sesionStatus: string;
        sessionProgres: string;
        sessionDetails: string;
        sessionResend: string;
        errorAudits: any[];
        sessionTypeString: string;
    }

@Component({
    components: {
        tabs: TabsComponent
    }
})

export default class SessionsComponent extends Vue {

    @Subscription(() => Cache.instance.isAdmin)
    isAdmin!: boolean | null;

    sessions: any[] | null = null;
    Sessioncreated = Session.RequestState.created;
    Sessionstarted = Session.RequestState.started;
    Sessioncompleted = Session.RequestState.completed;
    sessionEmpty = SessionRresults.empty;
    SessioncFailed = SessionRresults.sessionFailed;

    sessionInProgress = SessionRresults.sessionInProgress;

    loader = true;

    source: string = '';
    jpay = InmateSource.jpay;

    modal = {
        parameters: {
            show: false,
            session: null as SessionProgress | null
        },
        resend: {
            show: false,
            session: null as SessionProgress | null,
            rerunRegistration: false,
        },
        parametersTech: {
            show: false,
            session: null as SessionProgress | null,
        }
    }

    mySessions = true;
    sessionTypes = '0';


    async created() {
        this.source = this.$route.params.facilityId.split(':')[0];
        await this.getSessions();
    }

    async getSessions() {
        this.loader = true;

        try {

            const facilityId = this.$route.params.facilityId;
            let response;
            if (this.mySessions) {
                response = await this.$lantern.endpoints.Sessions.list({ facilityId, sessionType: this.sessionTypes, createdBy: this.$cache.user.value!.id }); // send without id if not checks
            } else {
                response = await this.$lantern.endpoints.Sessions.list({ facilityId, sessionType: this.sessionTypes });
            }
            if (!response) return;

            const sortedItems: SessionProgress[] = await Promise.all(
                response.data.items.sort((a: any, b: any) => {
                    return new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime();
                }).map(session => {

                    // count progress
                    const totalTask = session.studentCount + session.registrationCount;
                    const totalReady = (session.finishedEnrollment === undefined ? 0 : session.finishedEnrollment) + (session.finishedRegistration === undefined ? 0 : session.finishedRegistration);
                    const ready = Math.ceil((totalReady * 100) / totalTask);

                    // status
                    let sesionStatus: string;
                    if (session.requestState === this.Sessioncompleted && !session.hasErrors && ready === 100) {
                        sesionStatus = SessionRresults.completed;
                    } else if ((session.requestState === this.Sessioncompleted && ready !== 100 && !session.hasErrors) || (session.requestState === this.Sessionstarted && ready !== 0)) {
                        sesionStatus = SessionRresults.sessionInProgress;
                    } else if (session.hasErrors && ready === 0) {
                        sesionStatus = SessionRresults.sessionFailed;
                    } else if ((session.hasErrors && ready !== 0 && ready !== 100) || (session.hasErrors && session.requestState === this.Sessionstarted && ready === 100)) {
                        sesionStatus = SessionRresults.sessionPartialFailed;
                    } else {
                        sesionStatus = session.requestState.toString();
                    }

                    let sessionProgres = `${ready.toString()}%`;
                    if (sesionStatus !== SessionRresults.completed && sesionStatus !== SessionRresults.sessionInProgress.toString() && !Session.RequestState.created) {
                        sessionProgres = `100% (${ready.toString()})`;
                    }

                    let sessionDetails = SessionRresults.empty;
                    if (sesionStatus === this.Sessioncompleted || session.hasErrors) sessionDetails = SessionRresults.seeDetails;

                    const sessionResend = SessionRresults.resend;
                    // if (sesionStatus !== SessionRresults.completed || sesionStatus === SessionRresults.sessionPartialFailed.toString()) sessionResend = SessionRresults.resend;

                    let sessionTypeString = '';
                    if (session.type_session === 0 || !session.type_session) sessionTypeString = 'Student Enrollment';
                    if (session.type_session === 1) sessionTypeString = 'App Assignment';

                    return { ...session, sesionStatus, sessionProgres, sessionDetails, sessionResend, errorAudits: [], sessionTypeString };
                })
            );

            this.sessions = { ...sortedItems };
            console.log(this.sessions);

            this.loader = false;

        } catch (error) {
            this.loader = false;
        }
    }

    sortData(a: any, b: any) {
        return new Date(a.lastUpdated).getTime() - new Date(b.lastUpdated).getTime();
    }

    async loadDetails(session: SessionProgress, index: number) {
        this.sessions![index].sessionDetails = SessionRresults.sessionInProgress;
        if (session.sessionDetails === this.sessionEmpty) return;

        if (session.sesionStatus !== SessionRresults.completed) {
            const progress = await this.$lantern.endpoints.Sessions.getProgress(session.id, { createdOn: session.createdOn });

            // eslint-disable-next-line require-atomic-updates
            this.sessions![index].errorAudits = progress.data.errorAudits;
        }

        this.modal.parameters.show = true;
        this.modal.parameters.session = this.sessions![index];
        this.sessions![index].sessionDetails = SessionRresults.seeDetails;

    }

    async getSessionProgress(session: SessionProgress) {
        const progress = await this.$lantern.endpoints.Sessions.getProgress(session.id, { createdOn: session.createdOn });
        return progress.data.errorAudits;
    }

    async reSendQueue(session: any) {
        if (session.sessionResend === this.sessionEmpty) return;
        this.modal.resend.show = true;
        this.modal.resend.session = session;

    }

    async enqueueTask() {
        this.modal.resend.show = false;
        const session = this.modal.resend.session;

        // enqueue to amazon again
        try {
            // send enroll and apps sessions to different queue
            if (!session) {
                await alert('Something wrong with the session');
                return;
            }
            if (session?.type_session !== 1) {
                const messageEnqueued = await this.$lantern.endpoints.Aws.post({ id: session.id, createdOn: session.createdOn, rerunRegistration: this.modal.resend.rerunRegistration });
                if (messageEnqueued) {
                    await alert('Session re-started');
                }
            } else {
                const messageEnqueued = await this.$lantern.endpoints.Aws.enqueueAppsSession({ id: session.id, createdOn: session.createdOn });
                if (messageEnqueued) {
                    await alert('Session re-started');
                }

            }

        } catch (error) {
            await alert('Cannot enqueue your task! Please try later');
        }

        this.modal.resend.session = null;
        this.modal.resend.show = false;

    }

    async reloadInformation() {
        this.modal.resend.show = false;
        await this.getSessions();
    }

    async showIdDetails(session: SessionProgress) {
        console.log(session);

        this.modal.parametersTech.show = true;
        this.modal.parametersTech.session = session;
    }

    async saveSupportData() {
        console.log('yep');
    }

    @Watch('mySessions')
    async onmySessions() {
        await this.getSessions();
    }

    @Watch('sessionTypes')
    async onsessionTypes() {
        await this.getSessions();
    }
}
